// import { version } from '../system/version.js';
import { CommonSystemBridge } from './common-system-bridge.js'
import * as Text from '../bridges/common-text-bridge.js'
// User is exported from auth module
// import { default as HttpClient } from 'axios'
import * as Ramda from 'ramda'
import * as Types from '../app-types.js'
// import { AuthBridge } from './bridges/auth-bridge.js'
// import { DbBridge } from './bridges/db-bridge.js'
import { CommonDateBridge } from '../bridges/common-date-bridge.js'

export * as Data from '../bridges/common-data-bridge.js'
export * as Debug from '../bridges/common-debug-bridge.js'
export { CommonLanguageBridge as Language } from '../bridges/common-language-bridge.js'
export * as Math from '../bridges/common-math-bridge.js'
export * as RateLimiting from '../bridges/common-rate-limiting-bridge.js'
export * as User from '../bridges/common-user-bridge.js'
export * as Version from '../bridges/common-version-bridge.js'

export {
	// version as Version, // TODO: re-introduce this. Was removed due to problems importing JSON in frontend apps
	CommonSystemBridge as System,
	Text,
	// HttpClient,
	Ramda,
	Types,
	// User is exported from auth module
}
export let Date: CommonDateBridge // overridden
// export * from '../types.js'
export * from '../wait.js'
